import React, { Component } from "react";
import axios from "axios";
import Menu from '../../Menu/Menu'
import BackgroundView from "../View/BackgroundView";
import LayerView from "../View/LayerView";

class View2 extends Component {
  constructor(props) {
    super();
    this.state = {
      loaded: false
    };
  }

  loadstate = () => {
    axios({
      url: "https://api.caigoycreations.com/projects/getproject?Id="+this.props.match.params.ID,
      method: "get"
    }).then(
      res => {
        let tempState = res.data.data;
        console.log(res.data.data);
        let ratio = 300/res.data.data.DashboardWidth
        for (let i = 0; i < tempState.Inputs.length; i++){
          //calculate left:
          tempState.Inputs[i].Left = (tempState.Inputs[i].Left-tempState.DashboardLeft)*ratio 

          //calculate top:
          tempState.Inputs[i].Top = (tempState.Inputs[i].Top-tempState.DashboardTop)*ratio + 50

          //calculate width
          tempState.Inputs[i].Width = (tempState.Inputs[i].Width)*ratio

          ///calculate height
          tempState.Inputs[i].Height = (tempState.Inputs[i].Height)*ratio

        }

        //fill layers
        let tempLayerArray = [];
        for (let i = 0; i < tempState.Inputs.length; i++) {
          tempLayerArray.push(
            <LayerView
              parentUpdate={tempState.parentUpdate}
              index={i}
              key={i}
              visible={tempState.Inputs[i].Visible}
              //visible={true}
              //text
              text={tempState.Inputs[i].Text}
              textColor={tempState.Inputs[i].TextColor}
              font={tempState.Inputs[i].Font}
              fontSize={tempState.Inputs[i].FontSize}
              fontWeight={tempState.Inputs[i].FontWeight}
              fontStyle={tempState.Inputs[i].FontStyle}
              textAlign={tempState.Inputs[i].TextAlign}
              textDecoration={tempState.Inputs[i].TextDecoration}
              lineHeight={tempState.Inputs[i].LineSpace}
              textOpacity={tempState.Inputs[i].TextOpacity}

              //background
              backgroundColor={tempState.Inputs[i].BackgroundColor}
              opacity={tempState.Inputs[i].Opacity}

              //position
              left={tempState.Inputs[i].Left}
              top={tempState.Inputs[i].Top}
              width={tempState.Inputs[i].Width * ratio}
              height={tempState.Inputs[i].Height * ratio}
              rotateAngle={tempState.Inputs[i].RotateAngle}

              //picture
              isImage={tempState.Inputs[i].IsImage}
              imageUrl={tempState.Inputs[i].ImageUrl}
              ratio={tempState.Inputs[i].Ratio}
              pictureOpacity={tempState.Inputs[i].PictureOpacity}
              //border
              borderThickness={tempState.Inputs[i].BorderThickness}
              borderColor={tempState.Inputs[i].BorderColor}
              //callback to get child values
              parentsCallback={this.callbackFunction}
              ratio={ratio}
            />
          );
        }
        tempState.layers = tempLayerArray;
        tempState.loaded = true;
        this.setState(tempState);
        console.log(this.state.Inputs)

        //this.forceUpdate();
      },
      err => {
        alert("connection to api failed, please upload again" + err.data);
        console.log(err.data);
      }
    );
  };

  //displays each layer
  displayLayers = () => {
    let tempLayerArray = [];
    for (let i = 0; i < this.state.Inputs.length; i++) {
      tempLayerArray.push(
        <LayerView
          parentUpdate={this.state.parentUpdate}
          index={i}
          key={i}
          visible={this.state.Inputs[i].Visible}
          //text
          text={this.state.Inputs[i].Text}
          textColor={this.state.Inputs[i].TextColor}
          font={this.state.Inputs[i].Font}
          fontSize={this.state.Inputs[i].FontSize}
          fontWeight={this.state.Inputs[i].FontWeight}
          fontStyle={this.state.Inputs[i].FontStyle}
          textAlign={this.state.Inputs[i].TextAlign}
          textDecoration={this.state.Inputs[i].TextDecoration}
          lineHeight={this.state.Inputs[i].LineSpace}
          textOpacity={this.state.Inputs[i].TextOpacity}
          //background
          backgroundColor={this.state.Inputs[i].BackgroundColor}
          opacity={this.state.Inputs[i].Opacity}
          //position
          left={this.state.Inputs[i].Left}
          top={this.state.Inputs[i].Top + 50}
          width={this.state.Inputs[i].Width}
          height={this.state.Inputs[i].Height}
          rotateAngle={this.state.Inputs[i].RotateAngle}
          //picture
          isImage={this.state.Inputs[i].IsImage}
          imageUrl={this.state.Inputs[i].ImageUrl}
          ratio={this.state.Inputs[i].Ratio}
          pictureOpacity={this.state.Inputs[i].PictureOpacity}
          //border
          borderThickness={this.state.Inputs[i].BorderThickness}
          borderColor={this.state.Inputs[i].BorderColor}
          //callback to get child values
          parentsCallback={this.callbackFunction}
        />
      );
    }

    return tempLayerArray;
  };

  //used to syncronize child and parent components
  callbackFunction = childData => {
    let tempInputs = this.state.Inputs;
    tempInputs[childData.index].Left = childData.left;
    tempInputs[childData.index].Top = childData.top;
    tempInputs[childData.index].Width = childData.width;
    tempInputs[childData.index].Height = childData.height;
    tempInputs[childData.index].RotateAngle = childData.rotateAngle;

    this.setState({ Inputs: tempInputs, ParentUpdate: false });
  };

  componentWillMount() {}

  componentDidMount() {    
    //alert('hello');
    this.loadstate();
    console.log(this.props.match.params.ID)
  }

  render() {
    return (
      <div>
        <Menu />
        {
            this.state.loaded &&
            <div style={{position: 'absolute', top: '550px', zIndex: '1', width: '100vw', textAlign: 'center'}}>GUID: {this.state.GUID}</div>
        }
        {
          this.state.loaded && 
          <BackgroundView
            BackgroundColor={this.state.BackgroundColor}
            product={this.state.Product}
          
          />
        }
        <br />

        
        {this.state.loaded && this.displayLayers()}
      </div>
    );
  }
}

export default View2;
